"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _TextInput = _interopRequireDefault(require("../../components/TextFields/TextInput"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _BubbleSelectBlock = _interopRequireDefault(require("../../components/BubbleSelectBlock"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var Services = _interopRequireWildcard(require("../../services"));
var _theme = require("../../theme");
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _EntityTable = _interopRequireDefault(require("./EntityTable"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ClassesManagement = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(ClassesManagement, _PureComponent);
  function ClassesManagement() {
    var _this;
    (0, _classCallCheck2["default"])(this, ClassesManagement);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, ClassesManagement, [].concat(args)), _this.state = {
      showNewUser: false,
      currentUser: '',
      selectedClass: 'all',
      selectedClassID: '',
      showNewClass: false,
      title: '',
      titleError: false,
      description: '',
      descriptionError: false,
      isRetiree: '',
      isClassEdit: false,
      showRemoveModal: false
    }, _this._toggleAddClass = function () {
      _this.setState({
        showNewClass: !_this.state.showNewClass,
        title: '',
        description: '',
        isRetiree: false,
        isClassEdit: false
      });
    }, _this._toggleRemoveClass = function () {
      _this.setState({
        showRemoveModal: !_this.state.showRemoveModal
      });
    }, _this._validateClass = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var titleError, descriptionError;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Services.validateInput('className', _this.state.title);
          case 2:
            titleError = _context.sent;
            _context.next = 5;
            return Services.validateInput('checkEmpty', _this.state.description);
          case 5:
            descriptionError = _context.sent;
            if (_this.state.title.length < 1) {
              titleError = _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.classTitleRequired);
            } else if (_this.state.title.length > 20) {
              titleError = _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.classTitleLength);
            }
            if (_this.state.description && _this.state.description.length > 200) {
              descriptionError = _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.descriptionLength);
            }
            _this.setState({
              titleError: titleError,
              descriptionError: descriptionError
            });
            if (!(titleError || descriptionError)) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", false);
          case 11:
            return _context.abrupt("return", true);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._editClass = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var isValid, success;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this._validateClass();
          case 2:
            isValid = _context2.sent;
            if (isValid) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return");
          case 5:
            _context2.next = 7;
            return _this.props.editClass(_this.state.title.trim(), _this.state.description.trim(), _this.state.isRetiree, _this.state.selectedClass, _this.props.currentAccountMeta ? _this.props.currentAccountMeta.accountID : null);
          case 7:
            success = _context2.sent;
            if (success) {
              _this.setState({
                titleError: false,
                descriptionError: false
              });
              _this._toggleAddClass();
            }
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._openEditClass = function (classData) {
      _this.setState({
        showNewClass: true,
        title: classData.title.trim(),
        description: classData.description.trim(),
        isRetiree: classData.isRetiree,
        selectedClass: classData.classID,
        isClassEdit: true
      });
    }, _this._openRemoveClass = function (classData) {
      _this.setState({
        showRemoveModal: true,
        title: classData.title.trim(),
        description: classData.description.trim(),
        selectedClass: classData.classID
      });
    }, _this._removeClass = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var success;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this.props.removeClass(_this.state.selectedClass);
          case 2:
            success = _context3.sent;
            if (success) {
              _this.setState({
                showRemoveModal: false,
                selectedClass: null
              });
            }
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._addClass = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var isValid, success;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this._validateClass();
          case 2:
            isValid = _context4.sent;
            if (isValid) {
              _context4.next = 5;
              break;
            }
            return _context4.abrupt("return");
          case 5:
            _context4.next = 7;
            return _this.props.addClass(_this.state.title, _this.state.description, _this.state.isRetiree, _this.props.currentAccountMeta ? _this.props.currentAccountMeta.accountID : null);
          case 7:
            success = _context4.sent;
            if (success) {
              _this.setState({
                titleError: false,
                descriptionError: false
              });
              _this._toggleAddClass();
              window.location.reload();
            }
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), _this._handleInputChange = function (type, event) {
      _this.setState((0, _defineProperty2["default"])({}, type, event.target.value));
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(ClassesManagement, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var styles = {
        title: _theme.globalStyles.title,
        titleBlock: {
          display: 'flex',
          alignItems: 'center',
          marginBottom: 10
        }
      };
      var canCreateClass = false;
      if (this.props.currentAccountMeta.status === 3 && this.props.isMasterSite && this.props.step < 6) {
        // if the account is in revisions then only the master site can create classes
        canCreateClass = true;
      } else if (this.props.step <= 3 || this.props.isMasterSite && this.props.step < 5) {
        canCreateClass = true;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.titleBlock
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true
      }, "Classes"), canCreateClass && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        transparent: true,
        onClick: this._toggleAddClass,
        customStyle: {
          marginLeft: 'auto'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        style: {
          fontSize: 17,
          lineHeight: '14px',
          color: 'inherit'
        }
      }), "\xA0", _i18n["default"].t(_tokens["default"].buttons.createClass))), /*#__PURE__*/_react["default"].createElement(_EntityTable["default"], {
        items: this.props.classData,
        edit: !this.props.isMasterSite && this.props.step >= 4 ? null : this._openEditClass,
        remove: !this.props.isQuote ? null : !this.props.isMasterSite && this.props.step >= 4 ? null : this._openRemoveClass,
        language: this.props.language || "en"
      }), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showRemoveModal,
        close: this._toggleRemoveClass,
        title: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.removeClass),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this._removeClass,
        saveButtonText: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.removeClass),
        customContainerStyle: {
          maxWidth: "500px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true
      }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.removalConfirmation), " ", /*#__PURE__*/_react["default"].createElement("b", null, this.state.title), _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.removalConfirmationData)), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showNewClass,
        close: this._toggleAddClass,
        title: this.state.isClassEdit ? _i18n["default"].t(_tokens["default"].titles.editClass) : _i18n["default"].t(_tokens["default"].titles.newClass),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this.state.isClassEdit ? this._editClass : this._addClass
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.title),
        value: this.state.title,
        onChange: function onChange(value) {
          return _this2._handleInputChange('title', value);
        },
        error: Boolean(this.state.titleError),
        helperText: this.state.titleError,
        fullWidth: true,
        autofocus: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.description),
        value: this.state.description || '',
        onChange: function onChange(value) {
          return _this2._handleInputChange('description', value);
        },
        error: Boolean(this.state.descriptionError),
        helperText: this.state.descriptionError,
        fullWidth: true,
        autofocus: true
      }), this.props.isMasterSite && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true,
        customStyle: {
          marginTop: "20px"
        }
      }, _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.classRestrictionQuestion)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: this.state.isRetiree === true,
          field: 'isRetiree'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: this.state.isRetiree === false,
          field: 'isRetiree'
        },
        handleChange: function handleChange() {
          return _this2.setState({
            isRetiree: !_this2.state.isRetiree
          });
        }
      })), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement("span", {
        id: "classes-card"
      }));
    }
  }]);
  return ClassesManagement;
}(_react.PureComponent);
var _default = exports["default"] = ClassesManagement;